import React from 'react';
import {
  Calculator,
  Check,
  FileSpreadsheet,
  FileText,
  ListChecks,
  MessageSquare,
  Microscope,
  Music,
  PenTool,
  Wand2,
  BookOpen,
  GraduationCap,
  Search,
  Sparkles,
} from 'lucide-react';
import type { Bot } from '../types';

export const bots: Bot[] = [
  {
    id: 'afs-review',
    title: 'AFS Review Bot Suite',
    description: 'Comprehensive suite of tools for AFS review',
    icon: React.createElement(FileSpreadsheet, { className: "w-6 h-6" }),
    category: 'finance',
    subBots: [
      {
        id: '963d1382-1879-433b-ba60-26f8851fe330',
        title: 'AFS Review - Casts',
        description: 'Verify financial calculations and casts',
        price: 0.33,
        embedToken: 'pkd2e3c7bddbd10cb235b08443e89b523f',
        icon: React.createElement(Calculator, { className: "w-6 h-6" }),
        category: 'finance'
      },
      {
        id: 'aa898cc6-c205-49da-931c-9faa4fc5808e',
        title: 'AFS Review - Consistency',
        description: 'Check for internal consistency in financial statements',
        price: 0.22,
        embedToken: 'pk2e3541c2253b337f17bf9cc17b3d16e7',
        icon: React.createElement(Check, { className: "w-6 h-6" }),
        category: 'finance'
      },
      {
        id: '4d477a80-ee01-4005-a4aa-73918100f36c',
        title: 'AFS Review - Spelling',
        description: 'Review documents for spelling and grammar',
        price: 0.20,
        embedToken: 'pk130af8a8f4cbcf5aeded448b74ff10f6',
        icon: React.createElement(FileText, { className: "w-6 h-6" }),
        category: 'finance'
      },
      {
        id: '09d12ce5-f6d6-4f93-8780-956e9748d178',
        title: 'AFS Review - Disclosure',
        description: 'Prepare comprehensive disclosure checklists',
        price: 0.65,
        embedToken: 'pkcb46390350ad929df1b48006f8dfa599',
        icon: React.createElement(ListChecks, { className: "w-6 h-6" }),
        category: 'finance'
      },
      {
        id: 'dab38b2a-e853-4611-b9f7-bd692011b491',
        title: 'AFS Review - Other',
        description: 'Additional comprehensive financial checks',
        price: 0.80,
        embedToken: 'pk2d454b39cbebbd50e6a59c6f382c0324',
        icon: React.createElement(Microscope, { className: "w-6 h-6" }),
        category: 'finance'
      },
    ],
  },
  {
    id: '4f312b27-10fa-4cde-9e0a-e8bd3930d301',
    title: 'IFRS Specialist',
    description: 'Analyses and responds to technical IFRS queries',
    price: 0.60,
    embedToken: 'pk3cd729eb525a2ef7c91cba1c68d54be8',
    icon: React.createElement(BookOpen, { className: "w-6 h-6" }),
    category: 'finance'
  },
  {
    id: 'be61a96c-0fd8-45d7-8cb0-8b0b8be4896f',
    title: 'Audit Genius',
    description: 'Analyses and responds to technical audit queries',
    price: 0.60,
    embedToken: 'pk3816944da60acc706874aa1bbeab511d',
    icon: React.createElement(GraduationCap, { className: "w-6 h-6" }),
    category: 'finance'
  },
  {
    id: 'a2597ec6-7ea0-4873-842a-022d25acda34',
    title: 'Media Analyzer',
    description: 'Analyzes company websites and media for audit-relevant information',
    price: 0.90,
    embedToken: 'pka8c82c80804f15b2a128f1b1c4564b1c',
    icon: React.createElement(Search, { className: "w-6 h-6" }),
    category: 'finance'
  },
  {
    id: '92450f94-9d4d-4420-a7b0-fb0136010394',
    title: 'Audit Working Paper Reviewer',
    description: 'Review and analyze audit working papers',
    price: 1.20,
    embedToken: 'pk8214b45413e7e7d2a9c4ea02bf55c47d',
    icon: React.createElement(FileText, { className: "w-6 h-6" }),
    category: 'finance',
  },
  {
    id: '6fc972b7-d4c7-4e0d-a1be-c03697e7cff4',
    title: 'Client Meeting Analyzer',
    description: 'Analyze and summarize client meetings and discussions',
    price: 1.25,
    embedToken: 'pkf9271e8bf3a588e4cfbfad381568f6f1',
    icon: React.createElement(MessageSquare, { className: "w-6 h-6" }),
    category: 'finance',
  },
  {
    id: 'other-bots',
    title: 'Other AI Tools',
    description: 'Additional AI tools for various purposes',
    icon: React.createElement(Sparkles, { className: "w-6 h-6" }),
    category: 'other',
    subBots: [
      {
        id: '95b30ce0-8108-44ff-bcad-31b71c9f2fcd',
        title: 'PromptVersus',
        description: 'Compare responses from 7 leading LLMs side-by-side',
        price: 0.05, // Changed from null to a number to fix TypeScript error
        embedToken: 'pkefe50db52006ee75ccf060bf9b683e77',
        icon: React.createElement(PenTool, { className: "w-6 h-6" }),
        category: 'other'
      },
      {
        id: '37eb5559-3424-4abd-b699-e8bdfae9a4a5',
        title: 'Speechify',
        description: 'Convert text to natural-sounding speech',
        price: 0.15,
        embedToken: 'pkaadabeb2cae5b819669378438bf4069b',
        icon: React.createElement(Music, { className: "w-6 h-6" }),
        category: 'other'
      },
      {
        id: '663e2c4d-f224-440b-a12d-42b32ba7a407',
        title: 'Pixasso',
        description: 'Generate and edit images with AI',
        price: 0.12,
        embedToken: 'pkea57d341b3c7787e269c24dc14c000ee',
        icon: React.createElement(Wand2, { className: "w-6 h-6" }),
        category: 'other'
      },
      {
        id: 'b94a50ac-3bea-46d2-8c23-fa225b7ff079',
        title: 'Derek Prince',
        description: 'Interact with Derek Prince teachings',
        price: 0.01,
        embedToken: 'pk776b485a531f85759755f69663e6666a',
        icon: React.createElement(MessageSquare, { className: "w-6 h-6" }),
        category: 'other'
      }
    ]
  }
];